import {getAppConfig} from 'common/util/configUtil';
import { getAuthCredentials } from 'common/util/auth-storage';
import reqwest from 'reqwest';
import { map, flatMap, isEmpty, defer } from 'lodash';
import { removeMe } from 'common/actions/login';


export function queryGraphQL(queryString, variables, operationName) {
    const {graphqlUrl, corsOriginUrl} = getAppConfig();
    const { accessToken } = getAuthCredentials() || {};

    if (!accessToken) {
        removeMe();
        return defer(() => {
            window.location.replace('/?expiredSession=true');
        });
    }

    const headers = {
        'Authorization': `Bearer ${accessToken}`,
        'Access-Control-Allow-Origin': corsOriginUrl
    };

    const query = JSON.stringify({
        query: queryString,
        variables,
        operationName
    });

    const options = {
        method: 'post',
        url: graphqlUrl,
        type: 'json',
        crossOrigin: true,
        contentType: 'application/json',
        data: query,
        headers
    };

    return handleGraphQLErrors(reqwest(options));
}

export function mutateGraphQL(queryString, parameters, operationName) {
    return queryGraphQL(queryString, parameters, operationName);
}

export function handleGraphQLErrors(promise) {
    return promise.then(response => {
        if (!isEmpty(response.errors)) {
            response.formattedErrors = flatMap(response.errors, error => {
                if (!isEmpty(error.errors)) {
                    return map(error.errors, e => e.message);
                }
                if (error.message) {
                    return [error.message];
                }
                return [];
            });
        }
        return response;
    });
}

export function errorHandler(dispatch) {
    return function (err) {
        dispatch({
            type: 'ERROR',
            payload: {
                message: err.message
            }
        });
    };
}